export default "__VITE_ASSET__CEwqw7Ty__"